import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="empty-field-checker"
export default class extends Controller {
  static targets = [ "field" ]

  initialize() {
    this.initialFieldsValues = {}
    this.confirmed = false
  }

  connect() {
    if (this.hasFieldTarget) {
      this.fieldTargets.forEach((target) => {
        this.initialFieldsValues[target.id] = target.value
      })
    }
  }

  checkIfWillEmptyFields(event) {
    if (this.confirmed) {
      this.confirmed = false
      return
    }

    const isEmptyingFields = this.fieldTargets.some((target) => target.value == "" && this.initialFieldsValues[target.id] !== "")
    if (!isEmptyingFields) return

    event.preventDefault()
    event.stopPropagation()

    const confirmCopy = "You are about to delete an existing listing link, this will delete all existing reviews for such listing.\
                         \n\nAre you sure you want to continue?\
                         \n\nNote: If what you wish is to update the link and keep the existing reviews just replace the existing link with a new one and we won't delete the reviews"

    Turbo.config.forms.confirm(confirmCopy).then((confirmed) => {
      if (confirmed) {
        this.confirmed = true
        this.element.requestSubmit()
      }
    })
  }
}
